(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('EditOrderBagController', EditOrderBagController);

    EditOrderBagController.$inject = ['$timeout', '$scope', 'entity', '$stateParams', 'OrderBag', 'ServiceItemCustom', 'ServiceTimeSessionInfoCustom', 'ServiceTimeSessionCustom', 'CustomerCustom', '$translate', 'invoiceInfoEntity', 'OrderBagCustom', '$uibModal', 'OrderBagServiceItemCustom', 'InvoiceInfoCustom', 'ScheduleInfoCustom', 'CompanyInfoQuery', '$window', 'DEFAULT_VIDEO_CALL_URL', 'DialogService', '$mdDialog', '$state', 'PaymentLogCustom', 'PaymentLog', 'CompanyCustomerCustom', 'Principal', 'Servant'];

    function EditOrderBagController($timeout, $scope, entity, $stateParams, OrderBag, ServiceItemCustom, ServiceTimeSessionInfoCustom, ServiceTimeSessionCustom, CustomerCustom, $translate, invoiceInfoEntity, OrderBagCustom, $uibModal, OrderBagServiceItemCustom, InvoiceInfoCustom, ScheduleInfoCustom, CompanyInfoQuery, $window, DEFAULT_VIDEO_CALL_URL, DialogService, $mdDialog, $state, PaymentLogCustom, PaymentLog, CompanyCustomerCustom, Principal, Servant) {
        var vm = this;

        vm.orderBag = entity;

        // })
        vm.invoiceInfo = invoiceInfoEntity;
        vm.findStatusTitle = findStatusTitle;
        vm.findStatusStyle = findStatusStyle;
        vm.findBalanceStyle = findBalanceStyle;

        vm.clear = clear;
        vm.save = save;
        vm.serviceItem_changed = serviceItem_changed;
        vm.formState = "orderBagItem";
        vm.serviceSelected = serviceSelected;
        vm.hasParticipant = hasParticipant;
        vm.approveOrderBag = approveOrderBag;
        vm.cancelOrderBag = cancelOrderBag;
        vm.isBalanced = isBalanced;
        vm.constStatus = {};
        vm.constStatus.confirmed = 1;
        vm.constStatus.canceled = 4;
        vm.constStatus.reserveRequest = 5;
        vm.constStatus.requestConfirm = 6;
        vm.timeDiff = timeDiff;
        //vm.checkin = checkin;
        //vm.removeCheckIn = removeCheckIn;
        vm.removeCheckinOrderBagServieItem = removeCheckinOrderBagServieItem;
        vm.checkinOrderBagServieItem = checkinOrderBagServieItem;
        vm.notCheckinOrderBagServieItem = notCheckinOrderBagServieItem;
        vm.replaceTime = replaceTime;
        vm.insertPayment = insertPayment;
        vm.confirmReserveRequest = confirmReserveRequest;
        vm.showTimePeriod = showTimePeriod;
        vm.showReplaceTime = true;
        vm.goToVideoCall = goToVideoCall;
        vm.deleteOrderBagItem = deleteOrderBagItem;
        vm.canDeleteItem = false;
        vm.settlementInvoice = settlementInvoice;
        vm.deletePaymentLog = deletePaymentLog;
        vm.openMenu = openMenu;
        vm.originatorEv = null;
        vm.canReApproveRequestToPay = false;
        vm.canResendNotification = false;
        vm.reConfirmReserveRequest = reConfirmReserveRequest;
        vm.reSendNotification = reSendNotification;
        vm.goToCustomerDetail = goToCustomerDetail;
        vm.companyCustomer = null;

        canEditOrderBag();


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });


        $scope.$watch('vm.orderBag.orderBagServiceItems', function (ob) {

            if (ob != null) {
                if (ob != null && ob != undefined && ob.length > 0) {
                    canReplaceTime(ob[0].serviceItem.id);
                }
            }
        })

        $scope.$watch('vm.orderBag.status', function (s) {

            if (s != null) {
                checkOtherActions();
            }
        })


        function clear() {
            //$uibModalInstance.dismiss('cancel');
        }


        function save() {

            vm.isSaving = true;
            if (vm.orderBag.id !== null) {
                OrderBag.update(vm.orderBag, onSaveSuccess, onSaveError);
            } else {
                OrderBag.save(vm.orderBag, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:orderBagUpdate', result);

            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function serviceItem_changed() {

        }

        function serviceSelected() {
            //  vm.formState = "orderBagItem";
        }

        function findStatusTitle(status) {
            var result = "";

            result = $translate.instant("tikonApp.orderBag.status." + status);
            return result;
        }

        function findStatusStyle(status) {
            return "order-bag-status-" + status;
        }

        function hasParticipant() {
            var hasPP = false;

            angular.forEach(vm.orderBag.orderBagServiceItems, function (v) {
                angular.forEach(v.participantPersons, function (p) {
                    hasPP = true;
                });
            });


            return hasPP;
        }

        function approveOrderBag() {

            if (vm.orderBag.id != null)
                OrderBagCustom.approveReserve().save(vm.orderBag.id, onApproveSucces, onApproveError);
            //OrderBagCustom.approveOrderBag().save(vm.orderBag.id, onApproveSucces, onApproveError);
        }

        function onApproveSucces(result) {

            reload();
        }

        function onApproveError() {

        }

        function cancelOrderBag() {
            if (vm.orderBag.id != null) {
                DialogService.showConfirm("آیا از لغو اطمینان دارید ؟").then(function () {
                    OrderBagCustom.cancelReserve().save(vm.orderBag.id, onCancelSucces, onCancelError);

                });
            }
        }

        function onCancelSucces(result) {

            reload();
        }

        function onCancelError() {

        }

        function reload() {
            OrderBagCustom.getOrderBagWithEntities($stateParams.id).query(function (data) {

                vm.orderBag = data;

            });
            InvoiceInfoCustom.getInvoiceByOrderBagId($stateParams.id).query(function (data) {
                vm.invoiceInfo = data;
            });
            canEditOrderBag();

        }

        //function checkin()
        //{
        //
        //    if(vm.orderBag.id!=null )
        //    {
        //        OrderBagCustom.checkin().save(vm.orderBag.id,onCancelSucces,onCancelError);
        //    }
        //}

        function checkinOrderBagServieItem(orderBagServiceItemId) {

            if (orderBagServiceItemId != null) {
                OrderBagServiceItemCustom.checkinOrderBagServieItem().save(orderBagServiceItemId, onCancelSucces, onCancelError);
            }
        }

        function notCheckinOrderBagServieItem(orderBagServiceItemId) {

            if (orderBagServiceItemId != null) {
                OrderBagServiceItemCustom.notCheckinOrderBagServieItem().save(orderBagServiceItemId, onCancelSucces, onCancelError);
            }
        }

        function canEditOrderBag() {

            OrderBagCustom.canEditOrderBag($stateParams.id).query(function (data) {
                vm.resultStatus = data;
            });

        }

        //function removeCheckIn()
        //{
        //    if(vm.orderBag.id!=null ) {
        //        OrderBagCustom.removeCheckin().save(vm.orderBag.id,onSuccess,onError);
        //    }
        //}
        function removeCheckinOrderBagServieItem(orderBagServiceItemId) {
            if (orderBagServiceItemId != null) {
                OrderBagServiceItemCustom.removeCheckinOrderBagServieItem().save(orderBagServiceItemId, onSuccess, onError);
            }
        }

        function onSuccess() {
            reload();
        }

        function onError() {

        }

        function isBalanced() {
            return (vm.orderBag.remainAmount == 0);

        }

        function findBalanceStyle() {
            if (vm.orderBag.remainAmount == 0) {
                return "panel-success";
            } else {
                return "panel-danger";
            }
        }

        function replaceTime(orderBagItem) {

            // $mdDialog.show({
            //     templateUrl: 'app/components/partial-forms/edit-order-bag-service-item/partial-form.edit-order-bag-service-item.html',
            //     controller: 'EditOrderBagServiceItemComponentController',
            //     controllerAs: '$ctrl',
            //     backdrop: 'static',
            //     size: 'lg',
            //     resolve: {
            //         entity: function () {
            //             return {
            //                 orderBagItem: orderBagItem
            //             };
            //
            //         }
            //     },
            //     clickOutsideToClose: true
            // }).then(function (v) {
            //
            //     if(v)
            //     {
            //         orderBagItem.serviceTimeSession = v.serviceTimeSession;
            //         Servant.get({id : v.servant.id}).$promise.then(function (result) {
            //             orderBagItem.servant = result;
            //         });
            //         canEditOrderBag();
            //     }
            //
            // }, function () {
            //     //nothing
            // });
            //


            $uibModal.open({
                templateUrl: 'app/components/partial-forms/edit-order-bag-service-item/partial-form.edit-order-bag-service-item.html',
                controller: 'EditOrderBagServiceItemComponentController',
                controllerAs: '$ctrl',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return {
                            orderBagItem: orderBagItem
                        };

                    }
                },
                clickOutsideToClose: true
            }).result.then(function (v) {

                if (v) {
                    orderBagItem.serviceTimeSession = v.serviceTimeSession;
                    Servant.get({id: v.servant.id}).$promise.then(function (result) {
                        orderBagItem.servant = result;
                    });
                    canEditOrderBag();
                }
                //reload();
                // $uibModalInstance.close(result);
            }, function () {
                //nothing
                // $uibModalInstance.close(result);
            });

        }

        function insertPayment() {
            $uibModal.open({
                templateUrl: 'app/entities/payment-log/order-bag-payment-log-dialog.html',
                controller: 'OrderBagPaymentLogDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: ['$stateParams', function ($stateParams) {
                        return {
                            traceCode: null,
                            paymentType: null,
                            createDate: null,
                            id: null,
                            orderBagId: $stateParams.id
                        };
                    }]
                }
            }).result.then(function (v) {

                vm.invoiceInfo.paymentLogs.push({
                    id: v.id,
                    traceCode: v.traceCode,
                    paymentType: v.paymentType,
                    createDate: v.createDate,
                    amount: v.amount,
                });

                vm.orderBag.remainAmount -= v.amount;
                //reload();
            }, function () {
                //nothing
            });
        }

        function confirmReserveRequest() {
            if (vm.orderBag.id != null) {
                DialogService.showConfirm("ادامه عملیات را تائید می فرمایید ؟").then(function () {
                    OrderBagCustom.confirmReserveRequestByOrderBagId().save(vm.orderBag.id, onConfirmReserveSuccess, onConfirmReserveError);

                });
            }
        }

        function onConfirmReserveSuccess(result) {

            reload();
        }

        function onConfirmReserveError() {

        }

        function timeDiff(orderBagItem) {

            var d1 = new Date(orderBagItem.serviceTimeSession.endTime);
            var d2 = new Date(orderBagItem.serviceTimeSession.startTime);
            var min = 1000 * 60;
            //orderBagItem.timePeriod = (d1 - d2) / min;
            orderBagItem.timePeriod = 60;
        }

        function showTimePeriod(orderBagItemDtail, orderBagItem) {
            if (orderBagItem.startDate == orderBagItem.endDate && orderBagItemDtail.timeUnitQty > 1)
                return true;

            return false;

        }

        function canReplaceTime(serviceItemId) {

            // ScheduleInfoCustom.getCurrentScheduleInfoByServiceItem(serviceItemId).query().$promise.then(function (result) {
            //
            //     if (result.scheduleType == 'FLOAT_TIME_SESSIONS')
            //         vm.showReplaceTime = false;
            // })

            // var canReplaceTime = false;
            // //check servant is in serviceSeravnt list
            // ServiceItemCustom.getServiceServants(vm.orderBagServiceItem.serviceItemId).query(function (servants) {
            //     var servantid =  vm.orderBagServiceItem.serv;
            //     angular.forEach(servants, function (s) {
            //         if (servantid == s.id) {
            //             $ctrl.canReplaceTime = true;
            //         }
            //
            //     });
            // });

            vm.showReplaceTime = true;
        }

        function goToVideoCall(orderBagItem) {


            // $state.go('supplierPanel.joinVideoMeeting', {
            //     id: orderBagItem.id
            // });

            $mdDialog.show({
                controller: 'JoinVideoMeetingComponentController',
                templateUrl: 'app/components/partial-forms/join-video-meeting/partial-form.join-video-meeting.html',
                controllerAs: '$ctrl',
                resolve: {
                    entity: (function () {
                        return {
                            orderBagItem: orderBagItem
                        };
                    })

                },
                // parent: angular.element(document.body),
                // targetEvent: customerFormData,
                clickOutsideToClose: true
            })
                .then(function (answer) {

                    // $scope.status = 'You said the information was "' + answer + '".';
                }, function () {
                    // $scope.status = 'You cancelled the dialog.';
                });

        }


        function deleteOrderBagItem(itemId) {
            if (itemId != null) {
                DialogService.showConfirm("آیا از حذف آیتم اطمینان دارید ؟").then(function () {

                    OrderBagCustom.deleteOrderBagItem().save(itemId, onDeleteItemSuccess, onDeleteItemError);

                });
            }
        }

        function onDeleteItemSuccess(result) {
            reload();
        }

        function onDeleteItemError() {

        }

        function settlementInvoice() {

            if (vm.orderBag.remainAmount == 0 || vm.orderBag.finalPrice == 0)
                return;

            var paymentLog = {};
            paymentLog.amount = vm.orderBag.remainAmount;
            paymentLog.paymentType = 'UNKNOWN';
            paymentLog.orderBagId = vm.orderBag.id;

            PaymentLogCustom.createPaymentLogByOrderBagId().save(paymentLog, onSettlementSaveSuccess, onSettlementSaveError);


        }

        function onSettlementSaveSuccess(result) {
            vm.invoiceInfo.paymentLogs.push({
                id: result.id,
                traceCode: result.traceCode,
                paymentType: result.paymentType,
                createDate: result.createDate,
                amount: result.amount,
            });

            vm.orderBag.remainAmount -= result.amount;
        }

        function onSettlementSaveError() {

        }

        function deletePaymentLog(paymentLog) {

            if (paymentLog != null) {
                DialogService.showConfirm("آیا از حذف آیتم اطمینان دارید ؟").then(function () {

                    PaymentLogCustom.deletePaymentLogById().delete({id: paymentLog.id},
                        function () {
                            reload();
                        });

                });
            }
        }

        function openMenu($mdOpenMenu, ev) {
            vm.originatorEv = ev;
            $mdOpenMenu(ev);
        }

        function checkOtherActions() {
            if (!vm.orderBag || !vm.orderBag.status)
                return;
            vm.showOtherActionsButton = true;

            switch (vm.orderBag.status) {

                case vm.constStatus.confirmed :
                    vm.canReApproveRequestToPay = true;
                    vm.canResendNotification = true;
                    break;
                case vm.constStatus.canceled :
                    vm.canReApproveRequestToPay = true;
                    vm.canResendNotification = true;
                    break;
                case vm.constStatus.reserveRequest :
                    vm.canReApproveRequestToPay = false;
                    vm.canResendNotification = false;
                    vm.showOtherActionsButton = false;
                    break;
                case vm.constStatus.requestConfirm:
                    vm.canReApproveRequestToPay = false;
                    vm.canResendNotification = true;
                    break;
            }

            if (vm.orderBag.finalPrice == 0)
                vm.canReApproveRequestToPay = false;

        }


        function reConfirmReserveRequest() {
            if (vm.orderBag.id != null) {
                DialogService.showConfirm("ادامه عملیات را تائید می فرمایید ؟").then(function () {
                    OrderBagCustom.reConfirmReserveRequestByOrderBagId().save(vm.orderBag.id, onReConfirmReserveSuccess, onReConfirmReserveError);

                });
            }
        }

        function onReConfirmReserveSuccess(result) {

            reload();
        }

        function onReConfirmReserveError() {

        }

        function reSendNotification() {
            if (vm.orderBag.id != null) {
                DialogService.showConfirm("ارسال مجدد پیام را تایید می فرمایید ؟").then(function () {
                    OrderBagCustom.reSendNotificationByOrderBagId().save(vm.orderBag.id, function (result) {
                        // reload();
                    });

                });
            }
        }

        function goToCustomerDetail() {
            Principal.hasAuthority("ROLE_CUSTOMER_MANAGER")
                .then(function (result) {
                    if (result) {
                        CompanyCustomerCustom.findCompanyCustomerByCustomerId(vm.orderBag.customer.id).query().$promise.then(onGetSuccess);
                    }
                });
        }

        function onGetSuccess(result) {

            vm.companyCustomer = result;
            showCustomerPopUp(vm.companyCustomer.id);
            // $state.transitionTo('supplierPanel.companyCustomerPopUp', {id: });

        }


        function showCustomerPopUp(companyCustomerId) {
            $uibModal.open({
                templateUrl: 'app/entities/company-customer/company-customer-pop-up.html',
                controller: 'CompanyCustomerPopUpController',
                controllerAs: 'vm',
                backdrop: 'true',
                size: 'lg',

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        // $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('personInfo');
                        // $translatePartialLoader.addPart('serviceItem');
                        // $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['CompanyCustomer', function (CompanyCustomer) {
                        return CompanyCustomer.get({id: companyCustomerId}).$promise;
                    }],
                    formData: {
                        mode: 'EDIT',
                        isPopUp: true
                    }
                }
            }).result.then(function (v) {
                reload();
            }, function () {
                //nothing
            });
        }

    }
})();
